/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 */
import 'regenerator-runtime/runtime';

import '@fontsource/roboto/latin-300.css';
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/latin-700.css';

import '@fontsource/material-icons';
import '@fontsource/material-icons-rounded';
import '@fontsource/material-icons-outlined';
import '@fontsource/material-icons-sharp';
import '@fontsource/material-icons-two-tone';
import './base.css';

// FilePond French configuration
import './config/filepond-fr';

import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/integration/react';
import { createRoot } from 'react-dom/client';
import { ReactNotifications } from 'react-notifications-component';
import store, { persistor } from './store';
import App from './App';
import LocaleProvider from 'components/LocaleProvider';
import { MaterialUIControllerProvider } from 'context';

// Function to render the app
function renderApp(containerId = 'root', options = {}) {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container with id "${containerId}" not found`);
    return null;
  }

  if (options.initialRoute) {
    // Update the hash router to start at the specified route
    window.location.hash = options.initialRoute;
  }

  if (!window.dinaExternalOptions) {
    window.dinaExternalOptions = {
      assistant: options.assistant || null,
      ...options
    };
  }

  const root = createRoot(container);
  root.render(
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <CookiesProvider>
            <LocaleProvider>
              <HashRouter>
                <MaterialUIControllerProvider>
                  <ReactNotifications isMobile />
                  <App />
                </MaterialUIControllerProvider>
              </HashRouter>
            </LocaleProvider>
          </CookiesProvider>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  );

  return root;
}

// Auto-mount if #root exists (standalone mode)
if (document.getElementById('root')) {
  renderApp('root');
}

// Export function to window for external mounting
window.mountReactApp = renderApp;

// Export for potential ES6 imports
export default renderApp;
